import { HubConnection } from '@microsoft/signalr';

import { CensusDto } from '@medone/medonehp-api-client';

import { store } from '../../../../../shared/store';
import { updateCensus, updateCensusRoomNumber } from '../../census/slice';

const reloadPccCensus = (dto?: any) => {
    if (dto != null && dto.censusItems != null) {
        dto.censusItems.forEach((item) => {
            store.dispatch(updateCensus(CensusDto.fromJS(item)));
        });
    }
};

const onPatientTransfer = (dto: any) => {
    store.dispatch(updateCensusRoomNumber(CensusDto.fromJS(dto.census)));

    reloadPccCensus(dto);
};

export const removePccHubConnection = (connection: HubConnection) => {
    connection.off('patient.admit', reloadPccCensus);
    connection.off('patient.readmit', reloadPccCensus);
    connection.off('patient.cancelAdmit', reloadPccCensus);
    connection.off('patient.discharge', reloadPccCensus);
    connection.off('patient.cancelDischarge', reloadPccCensus);
    connection.off('patient.transfer', onPatientTransfer);
    connection.off('patient.cancelTransfer', reloadPccCensus);
    connection.off('patient.updateResidentInfo', reloadPccCensus);
    connection.off('patient.leave', reloadPccCensus);
    connection.off('patient.returnFromLeave', reloadPccCensus);
    connection.off('patient.cancelLeave', reloadPccCensus);
    connection.off('patient.cancelReturnFromLeave', reloadPccCensus);
    connection.off('patient.preAdmit', reloadPccCensus);
    connection.off('patient.outpatientToInpatient', reloadPccCensus);
    connection.off('patient.inpatientToOutpatient', reloadPccCensus);
    connection.off('patient.updateAccount', reloadPccCensus);
    connection.off('patient.updateAccountOnReturnFromLeave', reloadPccCensus);
    connection.off('patient.updateEpisodeofCare', reloadPccCensus);
};

export const initPccHubConnection = (connection: HubConnection) => {
    // ADT01 Events
    connection.on('patient.admit', reloadPccCensus);
    connection.on('patient.readmit', reloadPccCensus);
    connection.on('patient.cancelAdmit', reloadPccCensus);
    connection.on('patient.discharge', reloadPccCensus); // Update medone census
    connection.on('patient.cancelDischarge', reloadPccCensus); // Update medone census
    connection.on('patient.transfer', onPatientTransfer);

    // ADT02 Events
    connection.on('patient.cancelTransfer', reloadPccCensus);
    connection.on('patient.updateResidentInfo', reloadPccCensus);

    // ADT03 Events
    connection.on('patient.leave', reloadPccCensus);
    connection.on('patient.returnFromLeave', reloadPccCensus);
    connection.on('patient.cancelLeave', reloadPccCensus);
    connection.on('patient.cancelReturnFromLeave', reloadPccCensus);

    // ADT04 Events
    connection.on('patient.preAdmit', reloadPccCensus);

    // ADT05 Events
    connection.on('patient.outpatientToInpatient', reloadPccCensus);
    connection.on('patient.inpatientToOutpatient', reloadPccCensus);

    // ADT06 Events
    connection.on('patient.updateAccount', reloadPccCensus);
    connection.on('patient.updateAccountOnReturnFromLeave', reloadPccCensus);

    // ADT08 Events
    connection.on('patient.updateEpisodeofCare', reloadPccCensus);
};
